import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const { throwIsNotNumber } = ParameterErrors;
export default class Rect {
    constructor(props) {
        const { x, y, width, height } = props;
        if (!Validation.isNumber(x)) throwIsNotNumber("x");
        if (!Validation.isNumber(y)) throwIsNotNumber("y");
        if (!Validation.isNumber(width)) throwIsNotNumber("width");
        if (!Validation.isNumber(height)) throwIsNotNumber("height");
        this._x = x;
        this._y = y;
		this._width = width;
		this._height = height;
		this.containsPoint = this.containsPoint.bind(this);
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
	containsPoint(point){
		const x = point[0];
		const y = point[1];
		return (x>=this._x)&&(x<=this._x+this._width) && (y>=this._y)&&(y<=this._y+this._height);
	}
}
